import VernacManager from "./VernacManager";

export default VernacManager;
